import { useReducer } from 'react'
import * as R from 'ramda'
import { isEmptyOrNil } from 'libs/empty'
import useDebounce from 'libs/useDebounce'

const SEARCH_DEBOUNCE_TIME = 500 // in milliseconds

const SET_TEXT = 'SET_TEXT'
const RESET_TEXT = 'RESET_TEXT'

function reducer(state = '', action) {
  switch (action.type) {
    case RESET_TEXT:
      return undefined
    case SET_TEXT:
      return R.when(isEmptyOrNil, R.always(undefined), action.value)
    default:
      return state
  }
}

export const useSearch = () => {
  const [searchText, dispatch] = useReducer(reducer)

  const onChange = (event) =>
    dispatch({
      type: SET_TEXT,
      value: R.path(['target', 'value'], event),
    })

  const onReset = () => dispatch({ type: RESET_TEXT })

  const onClearSearch = () =>
    dispatch({
      type: SET_TEXT,
      value: undefined,
    })

  const debounceSearchText = useDebounce(searchText, SEARCH_DEBOUNCE_TIME)

  return { searchText, onChange, onReset, onClearSearch, debounceSearchText }
}
